import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';

import editIcon from 'images/icons/invite/edit.svg';
import { useEnterpriseContext } from '../../../contexts/EnterpriseContext';

import Filters from './Table/Filters';

import Tooltip from '../../ui/Tooltip';

import DeleteAction from './DeleteAction';

export default function Table({ userToken }) {
  const { dispatch, actions, state } = useEnterpriseContext();

  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('');
  const [manager, setManager] = useState('');
  const [contractType, setContractType] = useState('');

  const filteredItems = state.enterprises
    && Object.values(state.enterprises).filter((item) => {
      let available = false;
      if (
        item.attributes.name.toLowerCase().includes(keyword.toLowerCase())
        && item.attributes.status.toLowerCase().includes(status.toLowerCase())
        && item.attributes.policy_status.toLowerCase().includes(contractType.toLowerCase())
        && (manager == ''
          || (manager != ''
            && item.attributes.manager_ids.includes(parseInt(manager))))
      ) available = true;

      return available;
    });

  const editEnterprise = (e, row) => {
    document.querySelectorAll('.tooltip').forEach((el) => {
      el.remove();
    });

    document.location.href = `/enterprises/${row.id}/edit`;
  };

  const columns = [
    {
      name: 'Logo',
      selector: 'attributes.logo',
      sortable: false,
      cell: (row) => <img width="50px" src={row.attributes.logo} />,
    },
    {
      name: 'Company Name',
      selector: 'attributes.name',
      sortable: true,
    },
    {
      name: 'Date Created',
      selector: 'attributes.created_date_formatted',
      sortable: true,
      sortFunction: (a, b) => a.attributes.created_date_timestamp
        - b.attributes.created_date_timestamp,
    },
    {
      name: 'Account Manager',
      selector: 'attributes.account_manager',
      sortable: true,
    },
    {
      name: 'Status',
      selector: 'attributes.status',
      sortable: true,
      conditionalCellStyles: [
        {
          when: (row) => row.attributes.status == 'Blocked',
          style: {
            color: '#dc3545 !important',
          },
        },
        {
          when: (row) => row.attributes.status == 'Pending',
          style: {
            color: '#f68d2e !important',
          },
        },
        {
          when: (row) => row.attributes.status == 'Active',
          style: {
            color: '#6cc24a !important',
          },
        },
      ],
    },
    {
      name: 'Actions',
      sortable: false,
      width: '100px',
      cell: (row) => (
        <div>
          <a
            data-tip="Edit Enterprise"
            onClick={(e) => editEnterprise(e, row)}
            className="mr10"
          >
            <img src={editIcon} />
          </a>
          {row.attributes.status != 'Blocked' && (
            <DeleteAction enterpriseId={row.id} userToken={userToken} />
          )}
          <Tooltip />
        </div>
      ),
    },
  ];

  useEffect(() => {
    actions.loadEnterprises(dispatch);
  }, []);

  return (
    <>
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        setStatus={setStatus}
        setManager={setManager}
        setContractType={setContractType}
      />

      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={filteredItems || []}
          noDataComponent={(
            <div className="mt20">
              {' '}
              {state.enterprises == null
                ? 'Please, wait ...'
                : 'No matching records found'}
            </div>
          )}
          persistTableHead
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: 'All',
          }}
        />
      </div>
    </>
  );
}
